/** @jsx h */
import { h, Component, JSX } from 'preact';
import style from './index.css';

interface BlurProps {
  videoPlayer: HTMLVideoElement;
}

class Blur extends Component<BlurProps> {
  videoPlayer: HTMLVideoElement;
  videoCanvas: HTMLCanvasElement | null = null;

  constructor(props: BlurProps) {
    super(props);
    this.videoPlayer = this.props.videoPlayer;
  }

  componentDidMount(): void {
    this.captureAndDraw();
  }

  captureAndDraw(): void {
    const callback = () => {
      setTimeout(this.captureAndDraw.bind(this), 50);
    };
    if (!this.videoPlayer || !this.videoCanvas) return callback();
    if (this.videoPlayer.paused || this.videoPlayer.ended) return callback();
    const c = this.videoCanvas.getContext('2d');
    if (c) {
      c.drawImage(
        this.videoPlayer,
        0,
        0,
        this.videoCanvas.width,
        this.videoCanvas.height
      );
    }
    callback();
  }

  render(): JSX.Element | null {
    if (!this.videoPlayer) return null;

    const canvasStyle: Record<string, string> = {};
    const videoWidth = this.videoPlayer.videoWidth;
    const videoHeight = this.videoPlayer.videoHeight;

    // Should handle the two case of the blur effect:
    // - Interstitial Ad unit -> we need to fit on the height
    // - Header Ad unit -> we need to fit on the width
    if (
      window &&
      (window.innerWidth >= window.innerHeight ||
        // Handle case where the video is vertical and we should fit the  height
        this.videoPlayer.videoWidth < this.videoPlayer.videoHeight)
    ) {
      const containerSize = window.innerWidth;
      const ratio = containerSize / videoWidth;
      const height = Math.max(window.innerHeight, ratio * videoHeight);

      canvasStyle.width = containerSize + 'px';
      canvasStyle.height = height + 'px';
    } else {
      const containerSize = window.innerHeight;
      const ratio = containerSize / videoHeight;
      const width = Math.max(window.innerWidth, ratio * videoWidth);

      canvasStyle.width = width + 'px';
      canvasStyle.height = containerSize + 'px';
    }

    return (
      <div id="canvasContainer" className={style.canvasContainer}>
        <canvas
          id="canvas"
          className={style.canvas}
          style={canvasStyle}
          ref={(videoCanvas: HTMLCanvasElement | null) => {
            this.videoCanvas = videoCanvas;
          }}
        />
        <div id="blur" className={style.blur} />
      </div>
    );
  }
}

export default Blur;
